import * as React from 'react';
import classnames from 'classnames';
import styles from './Grid.scss';
/**
 * Container
 */

function Container(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.container, className)
  }, children);
}

Container.defaultProps = {
  className: undefined
};
/**
 * Row
 */

function Row(_ref2) {
  var children = _ref2.children,
      className = _ref2.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.row, className)
  }, children);
}

Row.defaultProps = {
  className: undefined
};
/**
 * Item
 */

function Item(_ref3) {
  var xl = _ref3.xl,
      lg = _ref3.lg,
      sm = _ref3.sm,
      xs = _ref3.xs,
      children = _ref3.children,
      className = _ref3.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(className, styles.item, styles["item_xl--".concat(xl)], styles["item_lg--".concat(lg || xl)], styles["item_sm--".concat(sm)], styles["item_xs--".concat(xs || sm)])
  }, children);
}

Item.defaultProps = {
  xl: 8,
  lg: undefined,
  sm: 4,
  xs: undefined,
  className: undefined
};
export default {
  Container: Container,
  Row: Row,
  Item: Item
};